import classnames from 'classnames'
import { Icon, NavLinkVue, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export type IInboxCellProps = {
  id: number
  name: string
  disabled?: boolean
  className?: string
}

export const InboxCell = ({ id, disabled, name, className }: IInboxCellProps) => (
  <NavLinkVue
    to={`/settings/organization/inboxes/all-inboxes/${id}`}
    className={classnames(styles.inboxCell, className, {
      [styles.inboxCell__block]: disabled,
    })}
    withoutStyles
  >
    <Icon icon='inboxes2' tertiary />
    <Typography
      ariaLabel='link'
      variant='body-md-regular'
      tooltipProps={{
        label: name,
        placement: 'top',
      }}
      ellipsis
    >
      {name}
    </Typography>
  </NavLinkVue>
)
